<template>
  <div class="text-gray-800 pb-2.5">
    <div
      class="flex items-center"
      :class="desktop ? 'gap-x-2.5' : 'gap-x-[11px]'"
    >
      <MembershipThumbnail class="w-[34px] shrink-0" />
      <span
        class="font-medium"
        :class="
          desktop ? 'text-[17px] leading-[24px]' : 'text-[22px] leading-[34px]'
        "
      >
        Dacr Pro Membership
      </span>
    </div>
    <p
      class="text-[15px] leading-[22px]"
      :class="desktop ? 'mt-[6px]' : 'mt-[5px]'"
    >
      The copyright system for working creators.
    </p>

    <div
      class="h-px bg-[#efefef]"
      :class="desktop ? 'mt-[18px] mb-5' : 'my-5'"
    />

    <div class="space-y-[9px]">
      <div class="text-[15px] font-medium leading-[18px]">
        Included with copyright registration
      </div>
      <div
        v-for="item in registrationBenefits"
        :key="item"
        class="flex items-start gap-x-3"
      >
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <span class="text-[15px] leading-[20px]">{{ item }}</span>
      </div>
      <div class="flex items-start gap-x-3">
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <span class="text-[15px] leading-[20px]">
          <span
            class="bg-linear-to-r from-yellow-500 via-[#F84600] to-[#CE489A] font-medium text-transparent"
            style="-webkit-background-clip: text; background-clip: text"
          >
            Dacr AI
          </span>
          infringement detection and DIIS reports
        </span>
      </div>
    </div>

    <div class="mt-[14px] space-y-[9px]">
      <div class="text-[15px] font-medium leading-[18px]">
        Included with Dacr Membership
      </div>
      <div class="flex items-start gap-x-3">
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <span class="text-[15px] leading-[20px]">
          Membership in the global community of protected creators
        </span>
      </div>
      <div class="flex items-start gap-x-3">
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <span class="text-[15px] leading-[20px]">Dacr Membership card</span>
      </div>
      <div class="flex items-start gap-x-3">
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <div>
          <div class="text-[15px] leading-[20px]">Member-only events</div>
          <div class="mt-1 text-[13px] leading-[18px] text-gray-500">
            Briefings, panels, workshops, and early access
          </div>
        </div>
      </div>
      <div
        v-for="item in membershipBenefits"
        :key="item"
        class="flex items-start gap-x-3"
      >
        <CheckmarkIcon class="mt-1 size-[13px] shrink-0" aria-hidden="true" />
        <span class="text-[15px] leading-[20px]">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckmarkIcon } from '@dacr/icons'

import MembershipThumbnail from '@/shared/components/account-menu/MembershipThumbnail.vue'

defineProps<{ desktop?: boolean }>()

const registrationBenefits = [
  'Official registration with court-ready Certificate',
  'Register your work in partner countries for official national recognition under local law',
  'Recognized worldwide under Berne and TRIPS',
]

const membershipBenefits = [
  'Co-owners and authors on every registration',
  'Register on behalf of others',
  'Direct member support',
]
</script>
